<div ngbDropdown display="dynamic" placement="bottom-end" #dropdown="ngbDropdown">
  <button type="button"
    class="btn d-flex justify-content-between w-100 {{ isDisabled ? 'disabled' : '' }}"
    ngbDropdownToggle (click)="onOpenDropdown()">
    <span *ngIf="showIcon" class="icon"><i class="bi bi-{{ iconClass }}"></i></span>
    <div class="inner d-flex justify-content-between w-100">
      <span class="text-gray-600" *ngIf="selectedOptionIsNotset()">{{ title }}</span>
      <span *ngIf="!selectedOptionIsNotset()" class="text-dark">{{ selectedOption?.replaceAll('_', ' ') }}</span>
      <span>
        <a *ngIf="!selectedOptionIsNotset() && isRequired" class="ms-2" (click)="removeSelected($event)">
          <i class="bi bi-x fw-bold"></i>
        </a>
        <span class="ms-2">
          <app-ac-icon-arrow-down></app-ac-icon-arrow-down>
        </span>
      </span>
    </div>
  </button>
  <div ngbDropdownMenu class="w-100">
    <div *ngIf="showSearch" class="p-2">
      <input (input)="search()" [(ngModel)]="searchKey" (keydown)="searchKeyDown($event)" #searchElement type="search" name="" class="form-control"
        placeholder="Type to search..." />
    </div>
    <div class="results">
      <button *ngFor="let item of filteredOptions" ngbDropdownItem (click)="onItemClick(item)"
        class="{{ selectedOption === item ? 'active ' + className: '' }}">{{ item?.replaceAll('_', ' ') }}</button>
    </div>
  </div>
</div>
